import { render } from "./TheVehicleDetails.vue?vue&type=template&id=0b4c205f&scoped=true"
import script from "./TheVehicleDetails.vue?vue&type=script&lang=js"
export * from "./TheVehicleDetails.vue?vue&type=script&lang=js"

import "./TheVehicleDetails.vue?vue&type=style&index=0&id=0b4c205f&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b4c205f"]])

export default __exports__